import { render, staticRenderFns } from "./project-create-from-template.vue?vue&type=template&id=33c6736d"
import script from "./project-create-from-template.vue?vue&type=script&lang=js"
export * from "./project-create-from-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports